export const onlyAlpha = (text: string) => {
  return `${text}`.replace(/[0-9]/g, '').replace(/[^\w\s]/gi, '');
};
